import { pickBy } from 'lodash';
import { EVENT_SOURCE } from 'tracking/constants';
import {
  isGroupTrackingEvent,
  isSessionTrackingEvent,
  NormalizedEvent,
  NormalizedGroupEvent,
  NormalizedSessionEvent,
  NormalizedStandaloneEvent,
  TrackingEvent,
} from '../events';

export function normalizeEvent(event: TrackingEvent): NormalizedEvent {
  if (isSessionTrackingEvent(event)) {
    const { name, ...rest } = event;
    return {
      event: name,
      eventSource: EVENT_SOURCE,
      ...rest,
    } satisfies NormalizedSessionEvent;
  }

  if (isGroupTrackingEvent(event)) {
    const normalizedEvent: NormalizedGroupEvent = {
      event: `${event.group} ${event.name}`,
      eventSource: EVENT_SOURCE,
      eventGroup: event.group,
      eventName: event.name,
      eventData: event.data,
      eventNonInteractive: event.nonInteractive,
    };

    return pickBy(normalizedEvent, Boolean) as NormalizedGroupEvent;
  }

  return {
    event: event.name,
    eventSource: EVENT_SOURCE,
    eventData: event.properties,
  } satisfies NormalizedStandaloneEvent;
}
